module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"exportedOn":"Exported on {date}"},"de":{"exportedOn":"Exportiert am {date}"}}')
  delete Component.options._Ctor
}
